export default __webpack_public_path__ + "static/media/img-0641-north-macedonia-full-face.10b2f96b.png";